import React from 'react';
import { motion } from 'framer-motion';
export function FailedSolutionsSection() {
  return <section className="py-24 px-4 bg-white" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl text-brown-light leading-relaxed" data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-8 text-center" data-id="element-32">
            El consejo tradicional dice: "Tienen que hablarlo".
          </h2>

          <p className="text-center font-bold text-terracotta text-2xl italic" data-id="element-33">
            Y ese es el peor consejo posible.
          </p>

          <p data-id="element-34">
            Porque intentar tener "la gran conversación" cuando ambos llevan
            semanas sin dormir, con las hormonas revueltas y la paciencia en
            cero... es una receta para el desastre.
          </p>

          <p data-id="element-35">
            Ya intentaron hablarlo. Y terminó en gritos, en llanto o en un
            silencio frío que duró dos días.
          </p>

          <p data-id="element-36">
            Ya intentaron "dejarse llevar". Y terminó con uno de los dos
            (probablemente tú) cargando con todo el peso mental.
          </p>

          <div className="bg-warm-gradient p-8 md:p-12 rounded-2xl my-12 shadow-inner border border-blush/20" data-id="element-37">
            <p className="font-bold text-brown text-center text-xl md:text-2xl mb-6" data-id="element-38">
              El problema no es la falta de amor.
            </p>
            <p className="text-center mb-6" data-id="element-39">
              El problema es que están tratando de resolver conflictos complejos
              con herramientas oxidadas. Están improvisando. Y cuando improvisas
              con sueño y estrés, siempre sale mal.
            </p>
            <p className="text-center font-serif text-2xl md:text-3xl text-terracotta font-bold italic" data-id="element-40">
              No necesitan más voluntad. Necesitan un guión.
            </p>
          </div>

          <p className="text-base text-brown-light/80 italic border-l-4 border-terracotta pl-4" data-id="element-41">
            La psicología conductual lo confirma: en momentos de alto estrés
            (como el posparto), el cerebro pierde capacidad para la empatía y la
            negociación creativa. Sin una estructura externa (un sistema),
            caemos automáticamente en patrones defensivos de ataque/huida. Por
            eso las "charlas espontáneas" fallan.
          </p>
        </motion.div>
      </div>
    </section>;
}